import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, Box, Typography } from "@mui/material";
import { t } from "i18next";
import { useSelector } from "react-redux";
import useAxiosFetchData from "../../hooks/useAxiosFetchData";
import {
  apiHostUrl,
  tagOldFeedbackReceipt,
  unTagOldFeedbackReceipt,
} from "../../../constants/constants";
import UntagFeedbackDialog from "./UntagFeedbackDialog";
import PluginSnackbar from "./Snackbar";
import styled from 'styled-components';


const TruncatedTypography = styled(Typography)`
  max-width: 200px; // Adjust this value as needed
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;


export default function AutoCompleteMultiSelectDropdown({
  values,
  onValueChange,
  taggedFeedbackList,
  feedbackId,
  id,
  bidderId,
  newFeedback=false,
}) {
  const [selectedValue, setSelectedValue] = React.useState(taggedFeedbackList);
  const { homeLink } = useSelector((state) => state.role);
  const { csrfToken } = useSelector((state) => state.csrf);
  const [performTagging, setPerformTagging] = useState(false);
  const [tagMode, setTagMode] = useState(0); // 0 for none, 1 for tag, 2 for untag
  const [headers, setHeaders] = useState({
    Accept: "*/*",
    "X-Csrf-Token": csrfToken,
    "Content-Type": "application/json",
  });
  const [tagFeedbackPayload, setTagfeedbackpayload] = useState(null);
  const [currFeedback, setCurrFeedback] = useState(null);
  const [comment, setComment] = useState(null);
  const [openUntagDialog, setOpenUntagDialog] = useState(false);
  const [removeFlag, setRemoveFlag] = useState(false);
  const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(
    t("general.label.untagged")
  );
  const closeSuccessSnackbar = () => {
    setOpenSuccessSnackbar(false);
  };
  const handleValueChange = (event, list, reason, detail) => {
    console.log("autocomplete", reason);
    if(newFeedback===true){
        onValueChange(list);
        setSelectedValue(list);
        return;
    }

    if (reason === "selectOption") {
      // onValueChange(event, list);
      console.log(detail.option);
      // setSelectedValue((prev)=>[...prev, detail.option]);
      setCurrFeedback(detail.option);
      setTagfeedbackpayload((prev) => ({
        ...prev,
        taggedFeedbackList: [{ feedbackCode: detail.option.feedbackCode , taggedFeedbackId: detail.option.feedbackId }],
      }));
      setPerformTagging(true);
      setTagMode(1);
    } else if (reason === "removeOption") {
      // setSelectedValue((prev)=>prev.filter((value)=>value.feedbackCode !== detail.option.feedbackCode));
      setCurrFeedback(detail.option);
      // setTagfeedbackpayload((prev) => ({ ...prev, "taggedFeedbackList": [{feedbackId:detail.option.feedbackId,comment:{}}] }));
      // setPerformTagging(true);
      // setTagMode(2);
      setRemoveFlag(true);
      setOpenUntagDialog(true);
      setTagfeedbackpayload((prev) => ({
        ...prev,
        taggedFeedbackList: [{ feedbackId: detail.option.feedbackId, comment: comment }],
      }));
    } else if (reason === "clear") {
      setSelectedValue([]);
      setTagfeedbackpayload((prev) => ({ ...prev, taggedFeedbackList: [] }));
      setPerformTagging(false);
      setTagMode(0);
    }

    // onValueChange(reason, list);
  };

  const { fetchData: tagFeedback } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${tagOldFeedbackReceipt}`,
    method: "post",
    body: tagFeedbackPayload,
    headers: headers,
    onLoad: false,
  });
  const { fetchData: untagFeedback } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${unTagOldFeedbackReceipt}`,
    method: "post",
    body: tagFeedbackPayload,
    headers: headers,
    onLoad: false,
  });
  useEffect(() => {
    setTagfeedbackpayload((prev) => ({
      departmentId: id,
      feedbackId: feedbackId,
      feedback: { userId: bidderId },
      ...prev,
    })); // REVIEW THIS
    if (removeFlag && comment && typeof comment === "string" && comment.length > 0) {
      setTagfeedbackpayload((prev) => ({
        ...prev,
        taggedFeedbackList: [
          {
            feedbackId: prev.taggedFeedbackList[0].feedbackId,
            comment: { commentGiven: comment },
          },
        ],
      }));
      // setSelectedValue((prev)=>prev.filter((value)=>value.feedbackCode !== currFeedback.option.feedbackCode));
      setPerformTagging(true);
      setTagMode(2);
      setRemoveFlag(false);
    }
    if (performTagging && !removeFlag) {
      if (tagMode === 1) {
        tagFeedback().then((response) => {
          if (response) {
            console.log("tagged", response);
            if (response.success === true) {
              // setSelectedValue((prev)=>prev.filter((value)=>value.feedbackCode !== currFeedback.feedbackCode));
              setSelectedValue((prev) => [...prev, currFeedback]);
              setOpenSuccessSnackbar(true);
              setSnackbarMessage(response.responseDetails);
            }
          }
        });
        setTagMode(0);
      } else if (tagMode === 2) {
        untagFeedback().then((response) => {
          if (response) {
            console.log("untagged", response);
            if (response.success === true) {
              setSelectedValue((prev) =>
                prev.filter(
                  (value) => value.feedbackCode !== currFeedback.feedbackCode
                )
              );
              setOpenSuccessSnackbar(true);
              setSnackbarMessage(response.responseDetails);
              setComment(null);
            }
          }
        });
        setTagMode(0);
      }
      setPerformTagging(false);
    }
  }, [performTagging, removeFlag, comment]);
  return (
    <div
      style={{ width: "-webkit-fill-available" }}
      className="custom-input-border-color"
    >
      <Autocomplete
        // PaperProps={{
        //     style: {
        //         maxHeight: '50vh',
        //         overflow: 'scroll',
        //     },
        // }}
        ListboxProps={{ style: { maxHeight: "20vh", overflow: "scroll" } }}
        disablePortal
        id="autoCompleteDropdown"
        options={values}
        value={selectedValue}
        multiple
        disableClearable
        sx={{ minWidth: "10vw", height: "auto" }}
        onChange={handleValueChange}
        getOptionDisabled={(option) => {
          //   debugger;
          return selectedValue.some(
            (value) => value.feedbackCode === option.feedbackCode
          );
        }}
        getOptionLabel={(option) =>
          option.feedbackDesc !== undefined
            ? `${option.feedbackCode} => ${option.feedbackDesc.replace(
                /(<([^>]+)>)/gi,
                ""
              )}`
            : `${option.feedbackCode}`
        }
        renderOption={(props, option) => (
          <Box
            component="li"
            sx={{ "& > :not(style)": { m: 0.5, width: "100%" } }}
            {...props}
          >
            <Typography variant="body2">{option?.feedbackCode}</Typography>
            <br />
            <TruncatedTypography variant="body2">
              {option?.feedbackDesc}
            </TruncatedTypography>
            <br />
            <Typography variant="body2">
              {new Date(option.createDate).toLocaleDateString('en-GB')}
            </Typography>
          </Box>
        )}
        isOptionEqualToValue={(option, value) =>
          option?.feedbackCode === value?.feedbackCode
        }
        renderInput={(params) => <TextField {...params} />}
        noOptionsText={t("general.label.nofeedback")}
      />
      <UntagFeedbackDialog
        open={openUntagDialog}
        setOpen={setOpenUntagDialog}
        returnComment={setComment}
      />
      <PluginSnackbar
        open={openSuccessSnackbar}
        message={snackbarMessage}
        onClose={closeSuccessSnackbar}
      />
    </div>
  );
}
